import ErrorBoundary from "./components/ErrorBoundary";
import ThemesProvider from "./providers/ThemeProvider";
import Routes from "./routes/index";

export default function App() {
  return (
    <ErrorBoundary>
      <ThemesProvider>
        <Routes />
      </ThemesProvider>
    </ErrorBoundary>
  );
}
